import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Switch } from 'antd';
import {
  addSpecialtyAction,
  generateOnboardingScript,
} from 'src/modules/SuperAdmin/store/actions/specialty.action';
import { SuperAdminModal } from '../../../baseComponents';
import * as Yup from 'yup';
import { getFromStorage } from 'src/lib/storage';
import { useSelector } from 'react-redux';
import { getGeneratedScriptSlice } from 'src/modules/SuperAdmin/store/slices/specialty.slice';

const AddSpecialty = ({ isOpen, setIsOpen, isfilterOn, selectedSpecialty }) => {
  const dispatch = useDispatch();
  const [isPublic, setIsPublic] = useState(false);
  const [specialty, setSpecialty] = useState(null);

  const cachedUserEmail = getFromStorage(`user_email`);
  const { generatedScript, generatedScriptLoading } = useSelector(
    (state) => state?.specialtyState
  );

  const initialValues = {
    specialty_name: specialty ? specialty : '',
    onboarding_script:
      generatedScript?.onboarding_script?.conversation &&
      JSON.stringify(generatedScript?.onboarding_script),
  };

  const validationSchemaField = Yup.object().shape({
    specialty_name: Yup.string()
      .trim()
      .required('Specialty name is required')
      .test(
        'not-only-whitespace',
        'Specialty name cannot be only whitespace',
        (value) => {
          return value && value.trim().length > 0;
        }
      ),
    onboarding_script: Yup.string()
      .trim()
      .required('Onboarding script is required')
      .test(
        'not-only-whitespace',
        'Onboarding script cannot be only whitespace',
        (value) => {
          return value && value.trim().length > 0;
        }
      ),
  });

  const sections = [
    {
      heading: (
        <>
          <div className="flex">
            <div>Add specialty</div>
          </div>
          <div className="mb-4 mt-4">
            <span className="text-sm" style={{ fontWeight: 'normal' }}>
              Public
            </span>
            <Switch
              className="mx-1"
              style={{ backgroundColor: '#00000040' }}
              value={isPublic}
              onChange={(e) => setIsPublic(e)}
            />
          </div>
        </>
      ),

      fields: [
        {
          name: 'specialty_name',
          type: 'text',
          title: (
            <>
              Specialty name <span style={{ color: '#c70039' }}>*</span>
            </>
          ),
          placeholder: 'Specialty name',
          onChange: (setFieldValue, e) => {
            setFieldValue('specialty_name', e?.target?.value);
            setSpecialty(e?.target?.value);
          },
        },
        {
          name: 'onboarding_script',
          type: 'modalTextArea',
          title: (
            <>
              Onboarding script <span style={{ color: '#c70039' }}>*</span>
            </>
          ),
          placeholder: 'Enter Onboarding script',
          className: 'mt-5',
          disabled: generatedScriptLoading,
        },
      ],
    },
  ];

  const handleCancel = () => {
    setIsOpen(false);
    setIsPublic(false);
    dispatch(getGeneratedScriptSlice({}));
    setSpecialty(null);
  };

  const handleGenerateScript = () => {
    dispatch(generateOnboardingScript(specialty));
  };

  return (
    <SuperAdminModal
      open={isOpen}
      sections={sections}
      validationSchema={validationSchemaField}
      initialValues={initialValues}
      className={'specialty-modal'}
      closable={false}
      submitButtonText="Submit"
      cancelButtonText="Cancel"
      additionalTitleButtonText={
        !generatedScriptLoading ? 'Generate script' : 'Generating...'
      }
      handleCancel={handleCancel}
      handleGenerateScript={handleGenerateScript}
      handleSubmit={(values) => {
        const payload = {
          specialty_name: values?.specialty_name,
          is_public: isPublic,
          created_by: cachedUserEmail,
          onboarding_script: JSON.parse(values?.onboarding_script),
        };
        dispatch(
          addSpecialtyAction(
            payload,
            setIsOpen,
            setIsPublic,
            isfilterOn,
            selectedSpecialty,
            setSpecialty
          )
        );
      }}
    />
  );
};

export default AddSpecialty;
